export default __webpack_public_path__ + "static/media/login__logo.b43f7cce.png";